import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatBalance, formatNull } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';
import LoadingLines from '../../LoadingLines';

import IconContainer from '../../IconContainer';
import { ReactComponent as ReloadIcon } from '../../../icons/reload.svg';

const NegativeBalances = ({  }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { userId } = useParams();

  const [cases, setCases] = React.useState([]);

  const [limitForView, setLimitForView] = React.useState(50);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-all-users-negative-balance?limitForView=${limitForView}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    .then((response) => {
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);
    
  React.useEffect(() => {
    if (confirmDeleteId !== null) {
      const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [confirmDeleteId]);


  return (
    <>
      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
            <div>
              <h3>Управляющие с отрицательным балансом</h3>
            </div>
            <a className='lastUpdateWrapper'>
                {loading ? 
                    <Loading type='inline' /> 
                : 
                    <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                }
            </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '25fr 25fr 40fr 10fr' }}>
              <div>Баланс</div>
              <div>ФИО и email</div>
              <div>Последние 5 транзакций</div>
          </div>
        </div>
        {(cases.length==0 && loading) ? <LoadingLines />
        : warning ? <WarningPanel text={warning} buttonText='Обновить' inTable={true} buttonAction={() => setReload(true)} />
        : cases.map((caseItem, index) => (
            <div 
                className='tableRow nonActive' 
                style={{ gridTemplateColumns: '25fr 25fr 40fr 10fr' }}
                key={index+caseItem.id} 
            >
                <div>
                  <span className='horizontalContainer'>
                    <p>{formatNull(formatBalance(caseItem.balance))+ ' ₽'}</p>
                    <p className='description'>Членские взносы</p>
                  </span>
                  <span className='horizontalLine'></span>
                  <span className='horizontalContainer'>
                    <p>{formatNull(formatBalance(caseItem.special_balance)) + ' ₽'}</p>
                    <p className='description'>Целевые взносы</p>
                  </span>
                </div>
                <div>
                    <Link 
                      className='aWithLink'
                      to={`/account/${caseItem.id}`}
                    >
                      {formatNull(caseItem.lastname)} {formatNull(caseItem.firstname)} {formatNull(caseItem.surname)}
                    </Link>
                    <a href={`mailto:${caseItem.email}`} className='aWithLink'>
                      {caseItem.email}
                    </a>
                </div>
                <div>
                    {caseItem.transactions.map((ts) => (
                        <p>{ts.action}{formatBalance(ts.amount)} ₽. {ts.description || 'Описание отсутствует'}</p>
                    ))}
                </div>
                <div style={{alignItems: 'end'}}>
                    <button 
                        type='button' 
                        className='tableButton blue'
                        onClick={() => window.open(`/account/${caseItem.id}?section=membership-fees`, '_blank')}
                    >
                        Просмотреть все транзакции
                    </button>
                    <p style={{fontSize: '11px', textAlign: 'center'}}>Откроется в новой вкладке</p>
                </div>
            </div>
        ))}
        {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
            <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div></div>
                <div>
                    <button
                        type='button'
                        className='button'
                        style={{ width: 'fit-content' }}
                        onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                        disabled={loading}
                    >
                        {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                    </button>
                </div>
                <div></div>
            </div>
        )}
      </div>
    </>
  )
}

export default NegativeBalances;